<mat-dialog-content>
    <h2>{{ headerText | translate }}</h2>
    <h2>{{ subjectTitle | translate }} {{ subjectName }}</h2>
    <form class="json-submit-form" [formGroup]="jsonForm" (ngSubmit)="onSubmit()">
        <mat-card-content class="content-block">
            @if (scopes.length > 0) {
                <div class="json-content">
                    <mat-button-toggle-group value="{{chosenScopeSelectionType}}" name="scopeSelectorTabs"
                                             aria-label="Scope selector">
                        @for (scopeSelectionType of scopeSelectionTypes; track scopeSelectionType) {
                            <mat-button-toggle
                                (click)="changeSelectionType(scopeSelectionType); drawer.toggle(chosenScopeSelectionType === scopeSelectionEnum.pick)"
                                value="{{scopeSelectionType}}"
                            >
                                {{ "scope." + scopeSelectionType | translate }}
                            </mat-button-toggle>
                        }
                    </mat-button-toggle-group>
                </div>
            }
            <mat-drawer-container class="example-container" autosize>

                <mat-drawer #drawer class="example-sidenav" mode="side">
                    @if (chosenScopeSelectionType === scopeSelectionEnum.pick) {
                        <app-scope-selection [scopes]="scopes"/>
                    }
                </mat-drawer>

                <json-editor matInput [options]="editorOptions"
                             [ngClass]="{ 'is-invalid': submittedAtLeastOnce && f.json.errors }"
                             formControlName="json">
                </json-editor>

            </mat-drawer-container>
        </mat-card-content>
        @if (!readOnly) {
            <mat-card-actions>
                <app-button
                    class="send-button"
                    [buttonType]="'primary'"
                    [label]="submitText | translate"
                    [disabled]="waitingForResponse"
                    (clickEmitter)="onSubmit()">
                </app-button>
            </mat-card-actions>
        }
    </form>
</mat-dialog-content>
